module.exports = __webpack_public_path__ + "img/open_switch.7b770bf2.jpeg";